import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DayboardDateService {
  
  dateChanged$: Subject<any> = new Subject<any>();
  dayboardDate = new Subject<any>();

  constructor() { }

  
}
